import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import "../assets/styles/_animation.scss";

type Props = {
  children: React.ReactElement | string;
  className: string;
  animationClassName: string;
  delay?: string;
  duration?: string;
  rootMargin?: string;
};

export const ScrollTrigger = (props: Props) => {
  const { ref, inView } = useInView({
    rootMargin: props.rootMargin ? props.rootMargin : "-35% 0% -35% 0%",
    triggerOnce: true,
  });

  return (
    <span
      ref={ref}
      className={`${props.className} ${inView ? props.animationClassName : ""}`}
      style={{
        transitionDelay: props.delay ? props.delay : "",
        transitionDuration: props.duration ? props.duration : "",
      }}
    >
      {props.children}
    </span>
  );
};
